var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcCloseRounded = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.58875 16 0 12.4113 0 8C0 3.58875 3.58875 0 8 0C12.4113 0 16 3.58875 16 8C16 12.4113 12.4113 16 8 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.58875 16 0 12.4113 0 8C0 3.58875 3.58875 0 8 0C12.4113 0 16 3.58875 16 8C16 12.4113 12.4113 16 8 16ZM8 1.14282C4.21899 1.14282 1.14282 4.21899 1.14282 8C1.14282 11.781 4.21899 14.8572 8 14.8572C11.781 14.8572 14.8572 11.781 14.8572 8C14.8572 4.21899 11.781 1.14282 8 1.14282Z",
    fill: "#E84F48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.857 11.4274C10.7108 11.4274 10.5645 11.3716 10.453 11.2599L4.73874 5.5457C4.51547 5.32243 4.51547 4.96086 4.73874 4.73772C4.96188 4.51457 5.32358 4.51445 5.54672 4.73772L11.261 10.452C11.4842 10.6752 11.4842 11.0368 11.261 11.2599C11.1494 11.3716 11.0033 11.4274 10.857 11.4274Z",
    fill: "#E84F48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14267 11.4275C4.99643 11.4275 4.85031 11.3717 4.73874 11.26C4.51547 11.0368 4.51547 10.6751 4.73874 10.452L10.453 4.73776C10.6762 4.5145 11.0378 4.5145 11.261 4.73776C11.4841 4.96091 11.4842 5.3226 11.261 5.54575L5.54672 11.26C5.43515 11.3717 5.28891 11.4275 5.14267 11.4275Z",
    fill: "#E84F48"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCloseRounded, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-close-rounded.8589cfe1.svg";
export { ForwardRef as ReactComponent };